import { useMutation } from "@tanstack/react-query";
import { trpc } from "@utils/trpc";
import sdk from "@farcaster/miniapp-sdk";

const useBaseAuth = () => {
  const loginWithQuickAuthAPI = trpc.loginWithQuickAuth.useMutation();

  const loginWithBase = useMutation({
    mutationFn: async ({
      email,
    }: {
      email?: string;
    }): Promise<
      | {
          success: true;
          firebaseAuthToken: string;
        }
      | {
          success: false;
          error: "no-email" | "something-went-wrong";
        }
    > => {
      try {
        // Get Quick Auth token from Farcaster SDK
        const { token } = await sdk.quickAuth.getToken();

        // Call backend to verify and create/find user
        // Pass the current domain for preview deployment support
        const result = await loginWithQuickAuthAPI.mutateAsync({
          token,
          email,
          domain: window.location.hostname,
        });

        if (result.success) {
          return {
            success: true,
            firebaseAuthToken: result.firebaseAuthToken,
          };
        } else {
          // Needs email
          return {
            success: false,
            error: "no-email",
          };
        }
      } catch (error) {
        console.error("Base auth error:", error);
        return {
          success: false,
          error: "something-went-wrong",
        };
      }
    },
  });

  return {
    loginWithBase: loginWithBase.mutateAsync,
  };
};

export default useBaseAuth;
